const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tooth_1.1",
    "data-name": "tooth 1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 851.98 895",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 405.83,
    cy: 433.03,
    rx: 154.28,
    ry: 128.29,
    style: {
      fill: "#ec2027",
      stroke: "#c1272d",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.76,
    y1: 362.6,
    x2: 404.76,
    y2: 499.88,
    style: {
      fill: "none",
      stroke: "#c1272d",
      strokeMiterlimit: 10,
      strokeWidth: "2.5px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 404.75,
    cy: 432.39,
    rx: 84.4,
    ry: 70.16,
    style: {
      fill: "none",
      stroke: "#c1272d",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.24,
    y1: 477.82,
    x2: 284.93,
    y2: 516.05,
    style: {
      fill: "none",
      stroke: "#c1272d",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 519.08,
    y1: 344.71,
    x2: 464.77,
    y2: 382.93,
    style: {
      fill: "none",
      stroke: "#c1272d",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 466.6,
    y1: 481.32,
    x2: 518.74,
    y2: 522.36,
    style: {
      fill: "none",
      stroke: "#c1272d",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.76,
    y1: 343.3,
    x2: 346.91,
    y2: 384.34,
    style: {
      fill: "none",
      stroke: "#c1272d",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M243.44,213.85s-6.48-5.95-14.06-15.67c-8.16-10.46-10.65-16.53-11.51-22.56-.34-2.42-.36-4.39-.29-6.63.21-6.84,1.28-18.49,5.99-35.24,5.22-15.23,8.89-27.82,11.34-36.77,4.43-16.18,7.47-29.98,16.78-33.78,3.93-1.61,7.83-1.32,7.83-1.32,5,.36,6.96,2.89,13.15,6.21,3.79,2.03,7.73,3.3,15.62,5.84,3.17,1.02,7.88,2.53,14.23,3.95,2.9.65,6.54,1.36,11.84,2.12,16.65,2.38,30.59,2.41,40.15,2.4,6.62,0,10.85-.19,15.68-.75,5.93-.69,10.26-1.23,15.59-3.3,2.59-1.01,3.2-1.51,8.36-3.63,4.56-1.87,7.03-2.89,9.24-3.47,6.2-1.64,11.21-.08,15.78.91,3.71.8,10.93.98,25.35,1.34,11.97.3,25.75-2.14,52.82-7.03,22.24-4.01,20.57-4.3,22.42-4.16,28.06,2.22,45.46,39.7,60.02,71.08,15.49,33.37,12.66,45.15,10.35,50.94-3.73,9.35-11.11,15.6-19.66,22.85-8.16,6.91-14.25,10.23-33.84,20.51-34.16,17.93-46.03,22.26-56.83,25.78-17.39,5.66-24.67,6.03-31.8,4.26-2.6-.65-15.55-4.16-23.74-15.24-2.35-3.18-1.86-3.67-9.19-16.03-3.95-6.66-5.96-10.04-8.02-12.55-4.73-5.79-10.48-12.81-17.75-12.67-5.39.11-9.24,4.12-13.79,8.87-7.26,7.57-8.44,13.05-12.75,19.71-7.87,12.14-19.43,17.84-23.41,19.8-20,9.85-40.82,3.83-45.39,2.51-12.7-3.68-26.36-14.1-50.52-38.26Z",
    style: {
      fill: "#ec2027",
      stroke: "#010101",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartial);
export default __webpack_public_path__ + "static/media/partial.24f1c0b1c2eb607b779b9fd169da3dcd.svg";
export { ForwardRef as ReactComponent };